import common from './common.json';
import auth from './auth.json';
import homepage from './homepage.json';
import courses from './courses.json';
import lessons from './lessons.json';
import badges from './badges.json';
import admin from './admin.json';
import profile from './profile.json';
import tests from './tests.json';
import notifications from './notifications.json';
import onboarding from './onboarding.json';
import dashboard from './dashboard.json';
import forum from './forum.json';
import seo from './seo.json';
import privacyPolicy from './privacyPolicy.json';

import leaderboard from './leaderboard.json';
import achievements from './achievements.json';
import learningPaths from './learningPaths.json';
import professions from './professions.json';
import modules from './modules.json';

const ru = {
  common,
  auth,
  homepage,
  courses,
  lessons,
  badges,
  admin,
  profile,
  tests,
  notifications,
  onboarding,
  dashboard,
  forum,
  seo,
  privacyPolicy,
  leaderboard,
  achievements,
  learningPaths,
  professions,
  modules
};

export default ru; 